export const DownloadIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="27"
    height="27"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {/* Bottom container */}
    <path d="M3 15c0 2.83 0 4.24.88 5.12C4.76 21 6.17 21 9 21h6c2.83 0 4.24 0 5.12-.88C21 19.24 21 17.83 21 15" />

    {/* Arrow */}
    <path d="M12 3v13M12 16l4-4.375M12 16l-4-4.375" />
  </svg>
);

export const OnlineIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="75"
    height="75"
    viewBox="0 0 64 64"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {/* Monitor body */}
    <path d="M5 8.5h30.5c1.9 0 3.5 1.6 3.5 3.5v18.5H5V12c0-1.9 1.6-3.5 3.5-3.5Z" />
    <path d="M5 30.5v3.8c0 1.9 1.6 3.5 3.5 3.5H39" />

    {/* Monitor stand */}
    <path d="M18.5 38c-.2 3.2-.4 5.2-1 6.8" />
    <path d="M27 38c.2 3.2.4 5.2 1 6.8" />
    <path d="M16 45h14" />
    <path d="M13 48h20" />

    {/* Screen content frame */}
    <path d="M9 12.5h20v14.8H9Z" />

    {/* Chart bars */}
    <path d="M12.5 24h8.5" />
    <path d="M12.5 24v-3.2h2.5V24" />
    <path d="M17 24v-5h2.5v5" />
    <path d="M21.5 24v-7.5H24v7.5" />

    {/* Presenter in monitor */}
    <circle cx="24.8" cy="17.2" r="3.1" />
    <path d="M22.7 20.2c1.5 1.4 2.9 1.4 4.3 0" />
    <path d="M27.8 21.5l3 3.4" />
    <path d="M30.8 24.9c1.1 1.2 2.3.5 2.9-.4" />

    {/* Person head */}
    <path d="M47.5 25.5c-3.9-2.2-9.5-.2-10.8 4.2" />
    <path d="M36.7 29.7c-1.2 1.5-1.8 3.4-1.8 5.7" />
    <path d="M35 35.4l-1.4 2.2 1.8.4" />
    <path d="M35.4 38c-.2 2.7.7 4.5 3.6 4.8" />
    <path d="M39 42.8v4.3" />

    {/* Hair */}
    <path d="M38.1 29.2c.8 2.2 2.6 3.9 5.3 4.9" />
    <path d="M43.4 34.1c1.2.1 1.9.9 1.8 2.1-.1 1.5-1.2 2.6-2.5 3.2" />
    <path d="M49.8 31.2c1.5 3.4 1 6.2-.2 8.6 2.2.5 3.4 2.1 2.8 4.1-.5 1.6-1.6 3.1-1.3 5" />

    {/* Body / sitting person */}
    <path d="M39 47.1c3.7-.4 8.2-.3 10.1.5 3 1.3 4.7 5.9 4.8 11.2" />
    <path d="M39 47.1c-3.8 0-6.2 1.1-8.3 4.2l-3.8 5.4" />
    <path d="M26.9 56.7c-1.9-1.9-4.7-1.5-6.4.4l-1.5 1.7" />
    <path d="M19 58.8c3.9 4.4 8.8 5.7 12.3.5l2.9-4.4" />

    {/* Desk / laptop line */}
    <path d="M1.5 55.5h27" />
    <path d="M39 63l1-5.2c.2-1.1 1-1.8 2.1-1.8h13.4l-1 7" />

    {/* Small keyboard lines */}
    <path d="M9 47.8h16.5" />
    <path d="M8 50.5h19" />
    <path d="M7.2 53.2h21" />
  </svg>
);

export const OnsiteIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="75"
    height="75"
    viewBox="0 0 64 64"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {/* Office floor */}
    {/* <path d="M5 56h54" /> */}

    {/* Desk */}
    <path d="M31 36h24" />
    <path d="M34 36v20" />
    <path d="M52 36v20" />

    {/* Laptop / support device */}
    <path d="M38 27h12v9H38z" />
    <path d="M35.5 36h17" />
    <path d="M43.5 31.5h1" />

    {/* Client sitting on office chair */}
    <circle cx="17" cy="20" r="4" />
    <path d="M13.5 25c2.3 2 5 2 7 0" />
    <path d="M12 29c-2.4 1.4-3.7 4-3.7 7v5h12.9" />
    <path d="M21.5 29c2 1.2 3.1 3.1 3.5 5.3" />

    {/* Office chair back */}
    <path d="M8 32H5.8c-1 0-1.8.8-1.8 1.8V45c0 1 .8 1.8 1.8 1.8H18" />

    {/* Chair seat */}
    <path d="M7 47h15" />
    <path d="M14.5 47v5" />

    {/* Chair wheels */}
    <path d="M9.5 54h10" />
    <path d="M9.5 54l-2 2" />
    <path d="M19.5 54l2 2" />

    {/* IT representative */}
    <circle cx="42" cy="12" r="4" />
    <path d="M37.5 18c2.6 2.1 6.4 2.1 9 0" />

    {/* IT rep body */}
    <path d="M34.5 25c.7-4.2 3.4-6.5 7.5-6.5s6.8 2.3 7.5 6.5" />
    <path d="M36 25v11" />
    <path d="M48 25v11" />
    <path d="M36 36h12" />

    {/* Tie / professional IT look */}
    <path d="M40.5 20.5 42 23l1.5-2.5" />
    <path d="M42 23v7" />
    <path d="M42 30l-2 4" />
    <path d="M42 30l2 4" />

    {/* IT rep pointing / assisting */}
    <path d="M36 27l-6 6" />
    <path d="M30 33l-4-2" />

    {/* Small support signal */}
    <path d="M52 18c2 1.2 3.4 3.2 3.8 5.5" />
    <path d="M55 15c3 2 5 5.1 5.5 8.5" />
  </svg>
);
